import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordsSecurityValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) return null;

    const errors: ValidationErrors = {};

    if (value.length < 8) {
      errors['length'] = true;
    }
    if (!/(?=.*[a-z])/.test(value)) {
      errors['lowercaseLetter'] = true;
    }
    if (!/(?=.*[A-Z])/.test(value)) {
      errors['capitalLetter'] = true;
    }
    if (!/(?=.*\d)/.test(value)) {
      errors['digit'] = true;
    }
    if (!/(?=.*[^A-Za-z0-9\s])/.test(value)) {
      errors['specialSymbol'] = true;
    }

    return Object.keys(errors).length ? errors : null;
  };
}
